import styled from "@emotion/styled";
import { SpacingKey } from "src/types/emotion";

export type Margins = {
  marginInlineStart?: SpacingKey;
  marginInlineEnd?: SpacingKey;
  marginBlockStart?: SpacingKey;
  marginBlockEnd?: SpacingKey;
};

export const PromoTimerContainer = styled.div<{
  margins?: Margins;
  backgroundColor?: string;
  textColor?: string;
}>`
  --margin-inline-start: ${({ theme, margins }) =>
    theme.space[margins?.marginInlineStart || "space0"]};
  --margin-inline-end: ${({ theme, margins }) =>
    theme.space[margins?.marginInlineEnd || "space0"]};
  --margin-block-start: ${({ theme, margins }) =>
    theme.space[margins?.marginBlockStart || "space0"]};
  --margin-block-end: ${({ theme, margins }) =>
    theme.space[margins?.marginBlockEnd || "space0"]};
  width: 100%;
  min-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: var(--margin-block-start) var(--margin-inline-start)
    var(--margin-block-end) var(--margin-inline-end);
  padding: ${({ theme }) => `0 ${theme.space._12 || "12px"}`};
  background-color: ${({ backgroundColor }) => backgroundColor || "#990001"};
  border-radius: 8px;
  color: ${({ theme, textColor }) => textColor || theme.colors.tone.white};
`;

export const PromoTimerMessage = styled.div<{ textColor?: string }>`
  display: flex;
  place-items: center;
  gap: ${({ theme }) => theme.space.space8};
  color: ${({ theme, textColor }) => textColor || theme.colors.tone.white};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 600;
`;
